import { CommandMenu } from 'components/command-menu'
import { Providers } from 'components/hoc/providers'
import { RequireAuth } from 'components/hoc/require-auth'
import { ThemeProvider } from 'components/hoc/theme-provider'
import { ThrowAuth } from 'components/hoc/throw-auth'
import { Navbar } from 'components/navbar'
import { TailwindIndicator } from 'components/tailwind-indicator'
import { Toaster } from 'components/ui/toaster'
import { urlConfig } from 'config/url.config'
import { AppLogsPage } from 'pages/app-logs/app-logs-page'
import { MainPage } from 'pages/dashboard/dashboard-page'
import { ErrorPage } from 'pages/error-page'
import { LoginPage } from 'pages/login/login-page'
import { NotFoundPage } from 'pages/not-found-page'
import { ProjectLogsPage } from 'pages/project-logs/project-logs-page'
import { ErrorBoundary } from 'react-error-boundary'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

const App: React.FC = () => {
    return (
        <BrowserRouter>
            <ErrorBoundary FallbackComponent={ErrorPage}>
                <Providers>
                    <Navbar />
                    <Routes>
                        <Route
                            path={urlConfig.pages.dashboard}
                            element={
                                <RequireAuth>
                                    <MainPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path={urlConfig.pages.projectsLogs}
                            element={
                                <RequireAuth>
                                    <ProjectLogsPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path={urlConfig.pages.appLogs}
                            element={
                                <RequireAuth>
                                    <AppLogsPage />
                                </RequireAuth>
                            }
                        />
                        <Route
                            path={urlConfig.pages.login}
                            element={
                                <ThrowAuth>
                                    <LoginPage />
                                </ThrowAuth>
                            }
                        />
                        <Route path="*" element={<NotFoundPage />} />
                    </Routes>
                    <Toaster />
                    <CommandMenu />
                    {/*  */}
                    <ThemeProvider />
                    <TailwindIndicator />
                </Providers>
            </ErrorBoundary>
        </BrowserRouter>
    )
}

export default App
